<!-- To Do List -->
<div
    class="mp-to-do-list-card trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none"
    [class.component-rtl-enabled]="themeService.isRTLEnabled()"
>
    <div class="trezo-card-header d-sm-flex align-items-center justify-content-between">
        <div class="trezo-card-title">
            <h5 class="mb-0">
                To Do List
            </h5>
        </div>
        <div class="trezo-card-subtitle">
            <form class="search-box position-relative">
                <label class="text-black">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                </label>
                <input type="text" class="input-search d-block w-100 border-radius" placeholder="Search here.....">
            </form>
        </div>
    </div>
    <div class="trezo-card-content">
        <div class="table-style-two">
            <div class="basic-table table-responsive">
                <table class="table mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="fw-medium">
                                <div class="form-check mb-0">
                                    <input class="form-check-input" type="checkbox">
                                </div>
                            </th>
                            <th scope="col" class="fw-medium">
                                ID
                            </th>
                            <th scope="col" class="fw-medium">
                                Task Title
                            </th>
                            <th scope="col" class="fw-medium">
                                Assigned To
                            </th>
                            <th scope="col" class="fw-medium">
                                Due Date
                            </th>
                            <th scope="col" class="fw-medium">
                                Priority
                            </th>
                            <th scope="col" class="fw-medium">
                                Status
                            </th>
                            <th scope="col" class="fw-medium">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div class="form-check mb-0">
                                    <input class="form-check-input" type="checkbox">
                                </div>
                            </td>
                            <td class="text-body">#854</td>
                            <td>
                                <a routerLink="/dashboard/helpdesk-page/ticket-details" class="project-name fw-medium">
                                    Network Infrastructure
                                </a>
                            </td>
                            <td>Oliver Clark</td>
                            <td class="text-body">30 Apr 2025</td>
                            <td class="text-body">High</td>
                            <td>
                                <span class="trezo-badge">
                                    Finished
                                </span>
                            </td>
                            <td>
                                <div class="action-buttons d-flex align-items-center">
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> visibility </i>
                                    </button>
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> edit </i>
                                    </button>
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> delete </i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="form-check mb-0">
                                    <input class="form-check-input" type="checkbox">
                                </div>
                            </td>
                            <td class="text-body">#853</td>
                            <td>
                                <a routerLink="/dashboard/helpdesk-page/ticket-details" class="project-name fw-medium">
                                    Cloud Migration
                                </a>
                            </td>
                            <td>Ethan Baker</td>
                            <td class="text-body">25 Apr 2025</td>
                            <td class="text-body">Low</td>
                            <td>
                                <span class="trezo-badge pending">
                                    Pending
                                </span>
                            </td>
                            <td>
                                <div class="action-buttons d-flex align-items-center">
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> visibility </i>
                                    </button>
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> edit </i>
                                    </button>
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> delete </i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="form-check mb-0">
                                    <input class="form-check-input" type="checkbox">
                                </div>
                            </td>
                            <td class="text-body">#852</td>
                            <td>
                                <a routerLink="/dashboard/helpdesk-page/ticket-details" class="project-name fw-medium">
                                    Website Revamp
                                </a>
                            </td>
                            <td>Sophia Carter</td>
                            <td class="text-body">20 Apr 2025</td>
                            <td class="text-body">Medium</td>
                            <td>
                                <span class="trezo-badge inProgress">
                                    In Progress
                                </span>
                            </td>
                            <td>
                                <div class="action-buttons d-flex align-items-center">
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> visibility </i>
                                    </button>
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> edit </i>
                                    </button>
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> delete </i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="form-check mb-0">
                                    <input class="form-check-input" type="checkbox">
                                </div>
                            </td>
                            <td class="text-body">#851</td>
                            <td>
                                <a routerLink="/dashboard/helpdesk-page/ticket-details" class="project-name fw-medium">
                                    Mobile Application
                                </a>
                            </td>
                            <td>Ava Cooper</td>
                            <td class="text-body">15 Apr 2025</td>
                            <td class="text-body">High</td>
                            <td>
                                <span class="trezo-badge">
                                    Finished
                                </span>
                            </td>
                            <td>
                                <div class="action-buttons d-flex align-items-center">
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> visibility </i>
                                    </button>
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> edit </i>
                                    </button>
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> delete </i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="form-check mb-0">
                                    <input class="form-check-input" type="checkbox">
                                </div>
                            </td>
                            <td class="text-body">#850</td>
                            <td>
                                <a routerLink="/dashboard/helpdesk-page/ticket-details" class="project-name fw-medium">
                                    System Deployment
                                </a>
                            </td>
                            <td>Isabella Evans</td>
                            <td class="text-body">10 Apr 2025</td>
                            <td class="text-body">Low</td>
                            <td>
                                <span class="trezo-badge cancelled">
                                    Cancelled
                                </span>
                            </td>
                            <td>
                                <div class="action-buttons d-flex align-items-center">
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> visibility </i>
                                    </button>
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> edit </i>
                                    </button>
                                    <button type="button" class="p-0 bg-transparent d-inline-block lh-1 border-0">
                                        <i class="material-symbols-outlined"> delete </i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="text-end">
                <button class="add-new-task-btn d-inline-block border-radius transition fw-medium" type="button" (click)="toggleClass()">
                    <span class="d-inline-block position-relative">
                        <i class="material-symbols-outlined">
                            add
                        </i>
                        Add New Task
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Add New Popup -->
<div
    class="add-new-popup"
    [class.active]="classApplied"
>
    <div class="popup-dialog">
        <div class="trezo-card w-100 border-radius d-block bg-white border-0 shadow-none">
            <div class="trezo-card-header d-flex align-items-center justify-content-between">
                <div class="trezo-card-title">
                    <h5 class="mb-0">
                        Add New Task
                    </h5>
                </div>
                <div class="trezo-card-subtitle">
                    <button
                        (click)="toggleClass()"
                        class="p-0 border-0 lh-1 bg-transparent transition"
                    >
                        <i class="ri-close-fill"></i>
                    </button>
                </div>
            </div>
            <div class="trezo-card-content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Task Name
                            </label>
                            <input type="text" class="form-control" placeholder="Task name">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Assigned To
                            </label>
                            <select class="form-select">
                                <option selected>
                                    Select
                                </option>
                                <option value="1">
                                    Shawn Kennedy
                                </option>
                                <option value="2">
                                    Roberto Cruz
                                </option>
                                <option value="3">
                                    Juli Johnson
                                </option>
                                <option value="4">
                                    Catalina Engles
                                </option>
                                <option value="5">
                                    Louis Nagle
                                </option>
                                <option value="6">
                                    Michael Marquez
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Due Date
                            </label>
                            <input type="date" class="form-control">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Priority
                            </label>
                            <select class="form-select">
                                <option selected>
                                    Select
                                </option>
                                <option value="1">
                                    High
                                </option>
                                <option value="2">
                                    Medium
                                </option>
                                <option value="3">
                                    Low
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Status
                            </label>
                            <select class="form-select">
                                <option selected>
                                    Select
                                </option>
                                <option value="1">
                                    In Progress
                                </option>
                                <option value="2">
                                    Pending
                                </option>
                                <option value="3">
                                    Completed
                                </option>
                                <option value="4">
                                    Not Started
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <button
                        (click)="toggleClass()"
                        class="warn d-inline-block fw-medium border-0 border-radius transition"
                    >
                        Cancel
                    </button>
                    <button class="primary d-inline-block fw-medium border-0 border-radius transition">
                        <span class="position-relative d-inline-block">
                            <i class="material-symbols-outlined">
                                add
                            </i>
                            Create
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>